import React from 'react';
import PropTypes from 'prop-types';
import DataSelect from '../DataSelect';

function JobSelect({
  name,
  onChange,
  onValueChange = null,
  titleKey = 'title',
  value,
  noneTitle = null,
  params = {},
  url = '/resource/jobs',
}) {
  return (
    <DataSelect
      name={name}
      onChange={onChange}
      onValueChange={onValueChange}
      valueKey="id"
      titleKey={titleKey}
      value={value}
      noneTitle={noneTitle}
      params={params}
      url={url}
    />
  );
}

JobSelect.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  titleKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  noneTitle: PropTypes.string,
  params: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  url: PropTypes.string,
};

JobSelect.defaultProps = {
  onChange: undefined,
  onValueChange: null,
  titleKey: 'title',
  value: undefined,
  noneTitle: null,
  params: {},
  url: '/resource/jobs',
};

export default JobSelect;
